import { setFullName, fullName } from '../../utils/variables';

export function isValidFullName(name) {
  if (name.trim().includes(' ')) {
      return true;
  }
  return false;
}

export function removeFullName() {
  setFullName('');
  const name = document.querySelector('#fullName');
  if (name) {
    name.value = '';
    document
      .querySelector('.fullNameContinue__btn')
      .classList.add('disabled');
  }
}
